class beuszoControl {
    init() {

        //if (document.cookie.indexOf("beuszoblokk-closed") == -1)
        //{
            $('.scroll-top').css('bottom', '240px');
            setTimeout(function(){
                $('.beuszo-uzenetek-doboz-kont').addClass('bring-up');
            }, 3000)
        // } else {
        //     $('.beuszo-uzenetek-doboz-kont').remove();
        // }

    }

    closeme()
    {

        $('.scroll-top').css('bottom', '20px');
        $('.beuszo-uzenetek-doboz-kont').removeClass('bring-up').addClass('bring-down');

        // var szunet = new Date(new Date().getTime()+(3600*24*1*1000));
        // document.cookie = "beuszoblokk-closed=1; expires=" + szunet.toGMTString();

        return false;
    }

}


class sargaCsikControl {

    openRegdobozok(el)
    {
        popupMessageSystem.showWin('');
        $('.pms-message').empty();



        $.get('/index.php/hirlevel/dialogs/feliratkozasdialog', {r: new Date().getTime(), gomburl: $(el).data('belepesgomb')}, function(res){
            if (res != '')
            {
                $('.pms-message').html(res)

                $('.pms-main-win').css({
                    'width': $('.container:first').width()+'px',
                    'left': 'calc(50% - ('+$('.container:first').width()+'px / 2))',
                })



                var regDobozokItems = $('.lenyilo-reg-area .regisztracios-dobozok').clone().removeClass('hide');
                $('.pms-message .regdobozok-kont').append(regDobozokItems)

                var sargacsikSzoveg = $('.hirlevel-sargacsik-kont .szoveg').html();
                $('.pms-message .topmessage-kont').append(sargacsikSzoveg)


            }
        }, 'html')


        return false;
    }
}


class popupSzettLista {

    constructor() {
        this.init();
    }

    init() {
        if ($('.item.kezdoszett a.openlist').length > 0)
        {
            $('.item.kezdoszett a.openlist').each((i, el) =>{
                $(el).on("click", (e) => {
                    e.preventDefault();
                    this.openMessage(e.target);
                })
            });
        }
    }

    openMessage(el) {
        popupMessageSystem.showWin('', 'szett-lista-win');
        $('.pms-message').empty();
        $('<div>').addClass('wait-datas').appendTo($('.pms-message'));

        $.get('/index.php/szettek/pupuplista', {szett_id: $(el).data('szett_id'), r: new Date().getTime()}, function(res){
            if (res != '')
            {
                $('.pms-message').html(res)
            }
        }, 'html')

    }
}


class termekAdatlapVideo {


    init ()
    {
        $('.main-content.ujadatlap .product-details .image-and-texts-kont .imgkont.video').each((i, vide) => {
            $(vide).on('click', (e) => {
                e.preventDefault();
                var vid = $(e.target);
                var tnev = "";
                if ($('.h1.oldalcim').length > 0) {
                    tnev = $('.h1.oldalcim').text().trim();
                }
                this.showPopUp(
                    vid,
                    tnev
                );
            });
        });
    }

    showPopUp (vid, termek_nev)
    {
        $('.pms-overlay, .termekadatlap-video-win').remove();

        var msgwin = $('<div>').addClass('termekadatlap-video-win');

        $('<div>').addClass('pms-overlay').on("click", function(e){e.preventDefault(); $('.pms-overlay, .termekadatlap-video-win').remove();}).appendTo($('body'));
        $('<a>').addClass('closeme').attr("href", "").on("click", function (e) { e.preventDefault(); $('.pms-overlay, .termekadatlap-video-win').remove(); }).appendTo(msgwin);

        var pVideo = $('<video>').attr('controls', '1');
        pVideo.attr('controlslist', 'nodownload');
        pVideo.attr('autoplay', '1');
        var pSource = $('<source>', pVideo).attr('type', 'video/mp4');

        if ($(vid).find('source').length == 0) {
            vid = $(vid).parents('.imgkont.video').find('video');
        }
        pSource.attr('src', $(vid).find('source').get(0).src);
        pSource.appendTo(pVideo);


        if (termek_nev != '')
        {
            var termnev_kont = $('<div>').addClass('termek-nev-line').text(termek_nev);
            termnev_kont.appendTo(msgwin);
        }

        $('<div>').addClass('video-kont').html(pVideo).appendTo(msgwin);
        msgwin.appendTo($('body'));
    }
}

class termeklistaVideoFelugro {

    constructor()
    {
        this.observers = [];
    }

    init ()
    {
        if ($('.webshop-termek-list-kont .productlist-kont .webshop-filter-result .item').length > 0)
        {
            $('.webshop-termek-list-kont .productlist-kont .webshop-filter-result .item').each((i, tItem) => {
                $(tItem).find('.video-popup-link').each((i, vidlink) => {
                    $(vidlink).on('click', (e) => {
                        e.preventDefault();
                        this.showPopUp(
                            $(e.target).attr('href'),
                            $(e.target).parents('.podor-product').data('termek_nev')
                        );
                    });
                });
            });
        }

        if ($('.product-category-list-container .item').length > 0)
            {
                $('.product-category-list-container .item').each((i, tItem) => {
                    $(tItem).find('.video-popup-link').each((i, vidlink) => {
                        $(vidlink).on('click', (e) => {
                            e.preventDefault();
                            this.showPopUp(
                                $(e.target).attr('href'),
                                $(e.target).parents('.podor-product').data('termek_nev')
                            );
                        });
                    });
                });
        }

        /*
        var obsTitems = document.querySelectorAll('.webshop-termek-list-kont .productlist-kont .webshop-filter-result .bgimage-kont');
        if (obsTitems.length > 0)
        {
            for (var obsTitemInd = 0; obsTitemInd < obsTitems.length; ++obsTitemInd)
            {
                var obsTitem = obsTitems[obsTitemInd];

                var observerItemLatszik = new IntersectionObserver(function (entries) {
                    if (entries[0].isIntersecting === true) {
                        var item = $(entries[0].target);

                        var imgEl = $('img', item);
                        if (imgEl.length > 0 && imgEl.attr('src') == '')
                        {
                            $.get('/index.php/webshoplist/loadbgimage', {termek_id: imgEl.parents('.podor-product').data('termek_id')}, function (imgElData) {
                                imgEl.attr({
                                    'src': imgElData.src,
                                    'srcset': imgElData.srcset
                                })
                            })
                        }
                    }
                }, { threshold: [0.1] });
                observerItemLatszik.observe(obsTitem);
                this.observers.push(observerItemLatszik);
            }
        }
        */

    }

    showPopUp (vidsource, termek_nev)
    {
        $('.pms-overlay, .termekadatlap-video-win').remove();

        var msgwin = $('<div>').addClass('termekadatlap-video-win');

        $('<div>').addClass('pms-overlay').on("click", function(e){e.preventDefault(); $('.pms-overlay, .termekadatlap-video-win').remove();}).appendTo($('body'));
        $('<a>').addClass('closeme').attr("href", "").on("click", function (e) { e.preventDefault(); $('.pms-overlay, .termekadatlap-video-win').remove(); }).appendTo(msgwin);

        var pVideo = $('<video>').attr('controls', '1');
        pVideo.attr('controlslist', 'nodownload');
        pVideo.attr('autoplay', '1');
        var pSource = $('<source>').attr('type', 'video/mp4');
        pSource.attr('src', vidsource);
        pSource.appendTo(pVideo);

        $('<div>').addClass('video-kont').html(pVideo).appendTo(msgwin);


        if (termek_nev != '')
        {
            var termnev_kont = $('<div>').addClass('termek-nev-line').text(termek_nev);
            termnev_kont.appendTo(msgwin);
        }

        msgwin.appendTo($('body'));
    }
}


class NewsletterPopup {
    init () {
        if ($('#newsletterpopup').length > 0)
        {
            $('#newsletterpopup').on('click', function (e) {
                e.preventDefault();
                NewsletterPopup.showPopUp();
            })
        }


        if ($('body').hasClass('newsletter-popup-enabled'))
        {
            if ($('.webshoplista-kont').length > 0 || $('.main-content.ujadatlap').length > 0)
            {
                if (!localStorage.getItem('newsletter-popup-accepted')) {
                    NewsletterPopup.showPopUp();
                } else {
                    var storedDate = new Date(localStorage.getItem('newsletter-popup-accepted'));

                    // if (new Date() > storedDate)
                    {
                        NewsletterPopup.showPopUp();
                    }
                }
            }
        }

    }

    showPopUp () {
        $('.pms-overlay, .newsletter-popup-win').remove();

        $.get('/index.php/newsletter-popup?r='+new Date().getTime(), function (html) {

            if (html == '')
            {
                return false;
            }

            $('<div>').addClass('newletter-popup-layer pms-overlay').on("click", function(e){e.preventDefault(); NewsletterPopup.closePopup()}).appendTo($('body'));

            var msgwin = $('<div>').addClass('newletter-popup-win opened');
            $('<a>').addClass('closeme').attr("href", "").on("click", function (e) { e.preventDefault(); NewsletterPopup.closePopup() }).appendTo(msgwin);
            $('<div>').addClass('newletter-popup-content').html(html).appendTo(msgwin);
            msgwin.appendTo($('body'));

            email_signup_form_event_init();
        });
    }

    closePopup() {
        $('.pms-overlay, .newletter-popup-win').remove();

        var futureDate = new Date();
        futureDate.setMonth(futureDate.getMonth() + 2);
        var futureDateString = futureDate.toISOString();

        localStorage.setItem('newsletter-popup-accepted', futureDateString);

    }

}

class InfluencerRegisztracio {
    init () {
        $('.influencer-reg form').on('submit', function (e) {
            e.preventDefault();
            InfluencerRegisztracio.validateForm();

        })
    }

    validateForm () {
        var form = $('.influencer-reg form');

        $.post('/index.php/influencer/frontend-validate', form.serialize(), function (res) {
            if (res.errors && Object.keys(res.errors).length > 0)
            {
                $.each(res.errors, function (field, error) {
                    var fieldEl = form.find('[name="' + field + '"]');

                    // ha a fieldel checkbox, akkor a parent().parent()-hez adja hozzá, egyébként csak a parent()-hez
                    if (fieldEl.attr('type') == 'checkbox')
                    {
                        var errorEl = fieldEl.parent().parent().find('.error');
                        if (errorEl.length == 0) {
                            errorEl = $('<div>').addClass('error floated').appendTo(fieldEl.parent().parent());
                        }
                    } else {
                        var errorEl = fieldEl.parent().find('.error');
                        if (errorEl.length == 0) {
                            errorEl = $('<div>').addClass('error').appendTo(fieldEl.parent());
                        }
                    }
                    errorEl.text(error);
                })

                $.each(res.errors, function (field, error) {
                    if (field == 'email_exists_user') {
                        form.find('.error').text('');
                        form.find('.exist-user-forcelogin').removeClass('d-none');
                        form.find('.disable-if-exists input').each(function (i, el) {
                            $(el).prop('disabled', true).css('opacity', 0.3);
                        })
                    }
                });

                setTimeout(function () {
                    form.find('.error').text('');
                }, 5000);
            } else {
                form.off('submit').submit();
            }
        }, 'json');

    }

}

export {
    beuszoControl,
    sargaCsikControl,
    popupSzettLista,
    termekAdatlapVideo,
    termeklistaVideoFelugro,
    NewsletterPopup,
    InfluencerRegisztracio
};
